import Icon, { ICON_MAP } from '@mindtickle/icon';
import Label from '@mindtickle/label';
import cs from 'classnames';

import EllipsisTooltip from '@mindtickle/ellipsis-tooltip';
import { TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import { getPopupContainerOnBody } from '@mindtickle/utils';

import toHyphenatedString from '~/components/Navigation/utils/toHyphenatedString';
import { NavMenuHeadProps } from '../../types';
import { StyledNavMenuHead } from './styles';
import { ELLIPSIS_TOOLTIP_STYLE } from '../../../NavMenuItem/styles';

const NavMenuHead = ({
  isRouteActive,
  iconType,
  isCollapsed,
  menuName,
  handleClick,
  iconTypeKey,
  firstSubMenu,
  isOnlyMenuItem,
}: NavMenuHeadProps) => {
  const onMenuClickHandler = () => {
    handleClick({ firstSubMenu });
  };
  return (
    <StyledNavMenuHead
      data-testId={`nav-${toHyphenatedString({
        str: menuName,
      })}`}
      className={cs('nav-menu-head', {
        'collapsed-navigation-menu-head': isCollapsed,
        'expanded-navigation-menu-head': !isCollapsed,
        'nav-menu-active': isRouteActive,
        'only-menu-item': isOnlyMenuItem,
      })}
      onClick={onMenuClickHandler}
    >
      <div className="nav-menu-head-content-desktop">
        <div className="nav-menu-head-icon-wrapper">
          <Icon
            key={isRouteActive ? 'FILLED' : 'LIGHT'}
            type={ICON_MAP?.[iconType?.[iconTypeKey]]}
            className="nav-menu-head-icon"
          />
        </div>
        <Label
          type={cs('nav-menu-head-name', {
            'nav-menu-head-name-active': isRouteActive,
            [TEXT_TYPES.LABEL_LARGE_ACCENT]: isRouteActive,
            [TEXT_TYPES.LABEL_LARGE_DEFAULT]: true,
          })}
        >
          <EllipsisTooltip
            linesToClamp={2}
            wrapperClassName="menu-title"
            overlayStyle={ELLIPSIS_TOOLTIP_STYLE}
            title={menuName}
            getPopupContainer={getPopupContainerOnBody}
          >
            {menuName}
          </EllipsisTooltip>
        </Label>
      </div>
      <Label
        type={cs('nav-menu-head-name-bottom', {
          'nav-menu-head-name-active': isRouteActive,
          [TEXT_TYPES.LABEL_LARGE_ACCENT]: isRouteActive,
          [TEXT_TYPES.MAIN_MENU_COMPACT_MENU_ITEM]: true,
        })}
      >
        <EllipsisTooltip
          linesToClamp={2}
          overlayStyle={ELLIPSIS_TOOLTIP_STYLE}
          wrapperClassName="menu-title"
          title={menuName}
          getPopupContainer={getPopupContainerOnBody}
        >
          {menuName}
        </EllipsisTooltip>
      </Label>
    </StyledNavMenuHead>
  );
};

export default NavMenuHead;
